// IndexedDB queue for evidence recorded while offline.
const DB_NAME = 'peershare';
const STORE = 'evidence_queue';
const VERSION = 1;

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: 'localId' });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function tx(mode, fn) {
  return openDb().then((db) => new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const store = t.objectStore(STORE);
    const out = fn(store);
    t.oncomplete = () => resolve(out?.result ?? out);
    t.onerror = () => reject(t.error);
  }));
}

const notify = () => window.dispatchEvent(new Event('ps-queue-changed'));

export async function queueAdd(item) {
  const record = { localId: `q_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`, recorded_at: new Date().toISOString(), ...item };
  await tx('readwrite', (s) => s.put(record));
  notify();
  return record;
}

export function queueAll() {
  return tx('readonly', (s) => s.getAll());
}

export async function queueRemove(localId) {
  await tx('readwrite', (s) => s.delete(localId));
  notify();
}

export async function queueCount() {
  const all = await queueAll();
  return all.length;
}
